import React from 'react';
import Text from '../Text';

const PrivateText = (props) => {
  return (
    <div data-private>
      <Text {...props} />
    </div>
  );
};

export default PrivateText;
